import { useMemo } from 'react';
import { useIsDemo } from '@/hooks/common/useIsDemo';
import { useDemoUsers } from '@/hooks/common/useDemoUsers';
import { useSelectedOrgId } from '@/hooks/common/useSelectedOrgId';
import { buildContacts, buildConversations, type Contact, type Conversation } from '@/views/people/lib/data';

export function usePeopleData() {
  const isDemo = useIsDemo();
  const { profilePictures, userIds } = useDemoUsers();
  const selectedOrgId = useSelectedOrgId();

  const contacts: Contact[] = useMemo(
    () => (isDemo ? buildContacts(profilePictures, userIds, selectedOrgId) : []),
    [isDemo, profilePictures, selectedOrgId, userIds],
  );

  const conversations: Conversation[] = useMemo(
    () => (isDemo ? buildConversations(profilePictures, userIds, selectedOrgId) : []),
    [isDemo, profilePictures, selectedOrgId, userIds],
  );

  return { contacts, conversations };
}
